<template>
    <div class="container">
        <div class="max-w-md">
            <el-card class="bg-white">
                <h1 class="text-xl">学工号输入</h1>
                <p class="text-gray">请输入您的学工号进行签到</p>

                <el-form :model="form" :rules="rules" ref="form" label-position="top">
                    <el-form-item label="学工号" prop="student_sn">
                        <el-input v-model="form.student_sn" placeholder="请输入学工号" maxlength="20" show-word-limit
                            :disabled="loading"></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" class="w-full" @click="submitForm" :loading="loading">
                            <span>{{ loading ? '验证中' : '提交验证' }}</span>
                        </el-button>
                    </el-form-item>
                </el-form>
            </el-card>
            <el-button type="text" class="text-full" @click="backGo()">
                返回上一步
            </el-button>
        </div>
    </div>
</template>

<script>
import { scanConfirm } from "@/api/user"
import {
    setIdentifierToken,
} from "@/utils/auth"
export default {
    name: "student_id_input",
    data() {
        return {
            form: {
                student_sn: '',// 学工号
                code_key: ''// 扫码密钥
            },
            rules: {
                student_sn: [
                    { required: true, message: '请输入学工号', trigger: 'blur' },
                    { pattern: /^[0-9a-zA-Z]+$/, message: '学工号只能包含数字和字母', trigger: 'blur' }
                ]
            },
            loading: false
        };
    },
    components: {},
    created() {
        // 获取扫码密钥
        this.form.code_key = this.$route.query.code_key;
        setIdentifierToken(this.$route.query.identifier);
    },
    methods: {
        backGo() {
            this.$router.push({
                path: '/qrCode',
                query: {
                    code_key: this.form.code_key,
                    identifier: this.$route.query.identifier
                }
            });
        },
        submitForm() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    this.loading = true;
                    scanConfirm(this.form).then((response) => {
                        this.loading = false;
                        if (response.code === 0) {
                            // 验证成功，跳转到成功页面
                            this.$router.push({
                                path: '/qrCode/success',
                                query: {
                                    studentId: this.form.student_sn,
                                    name: response.data.info,
                                    date: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate(),
                                    time: new Date().getHours() + ":" + new Date().getMinutes() + ":" + new Date().getSeconds(),
                                }
                            });
                        } else {
                            // this.$message.error(response.message || '验证失败，请重试');
                        }
                    }).catch((error) => {
                        this.loading = false;
                        // this.$message.error('网络异常，请检查网络连接');
                        console.error('验证失败:', error);
                    });
                }
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.container {
    width: 100%;
    height: 100%;
    display: flex;
    overflow: hidden;
    background: #eff6ff;
    justify-content: center;
    flex-direction: column;

    .text-xl {
        text-align: center;
        font-size: 25px;
        color: rgb(37 99 235);
    }

    .max-w-md {
        display: flex;
        flex-wrap: nowrap;
        flex-direction: column;
        justify-content: center;
        width: 90%;
        margin: 0 auto;
    }

    .text-gray {
        text-align: center;
        color: rgb(107 114 128);
    }

    .w-full {
        background: rgb(37, 99, 235);
        width: 60%;
        height: 50px;
    }

    .text-full {
        color: rgb(37, 99, 235);
        margin-top: 15px;

    }
}

/* 自定义样式 */
.el-card {
    border: none;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
}

.el-button {
    border-radius: 12px;
    padding: 12px 0;
    font-size: 16px;
}

.el-input {
    border-radius: 8px;
}

::v-deep .el-form-item__content {
    text-align: center;
}

::v-deep .el-input__inner {
    height: 50px;
}
</style>